import { searchTenantOrganisations } from '@infuse/api/iam/tenant';
import { useGenericOrganisations } from '@infuse/iam/organisation/queries';

export const useTenantOrganisations = () =>
  useGenericOrganisations({
    apiFn: searchTenantOrganisations,
    queryKeys: ['organisations', 'tenant'],
    onlyEnableWithParentId: true
  });
